import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileComponent } from './profile.component';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../../../../common/authGuard/Auth.guard';
import { CardBookModule } from '@components/card-book/card-book.module';
import { CardEventModule } from '@components/card-event/card-event.module';
import { MatIconModule } from '@angular/material/icon';
import { DialogDetailBadgeComponent } from '../components/dialog-detail-badge/dialog-detail-badge.component';
import { ButtonModule } from '@components/button/button.module';
import { MatDialogModule } from '@angular/material/dialog';
import { UserWacaKoinModule } from '@components/user-waca-koin/user-waca-koin.module';

@NgModule({
	declarations: [ProfileComponent, DialogDetailBadgeComponent],
	imports: [
		CommonModule,
		RouterModule.forChild([
			{ path: '', component: ProfileComponent, canActivate: [AuthGuard] }
		]),
		MatIconModule,
		CardBookModule,
		CardEventModule,
		ButtonModule,
		MatDialogModule,
		UserWacaKoinModule
	]
})
export class ProfileModule {}
